import ReportingStandards from './ReportingStandards';
export { ReportingStandards };
export default ReportingStandards;
